import { authHeader } from './auth.services';
import { apiServer } from '../globalVars';
import { userService } from './user.service';

export const empleadoService = { getEmpleado, loadStoragedEmpleado };

function getEmpleado(empleadoId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  return fetch(`${apiServer}/empleado/${empleadoId}/puesto`, requestOptions)
    .then(handleResponse)
    .then(empleado => {
      localStorage.setItem('empleado', JSON.stringify(empleado));
      return empleado;
    });
}

function loadStoragedEmpleado() {
  if (localStorage.getItem('empleado') != null) {
    let empleado = JSON.parse(localStorage.getItem('empleado'));
    return empleado;
  }
  return null;
}

function handleResponse(response) {
  return response.text().then(text => {
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.logout();
        location.reload(true);
      }
      const data = text && JSON.parse(text);
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    } else {
      return text && JSON.parse(text);
    }
  });
}